var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "x-button",
    { staticClass: "logout-button full-width", on: { click: _vm.exit } },
    [
      _c("ic-logout", { staticClass: "icon-logout" }),
      _vm._v("\n  " + _vm._s(_vm.$t("buttons.logout")) + "\n")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }